<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{ $t('message.Subscriptions') }}</h2>
        </div>
      </div>

      <div class="tab-subcription">
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab :title="$t('message.Active')">
            <div class="container" v-if="allActiveSubscription.length>0">
              <div v-for="(item, index) in allActiveSubscription" :key="index">
                <div class="panel orderList" v-if="item.Subscriptionstatus=='active'">
                  <div v-on:click="gotoDetails(item,'active')">
                    <div class="orderContainer">
                      <div class="productImageOrder">
                        <img class="svg" v-lazy="imageBaseUrl+item.image" alt="placeholder" />
                      </div>
                      <div class="orderDetailLeft">
                        <h4>{{item.productName}}</h4>
                        <p>
                          <!-- <b>Quantity-</b>
                          {{item.productQuantity}}-->
                        </p>
                        <p>
                          <b>{{ $t('message.Schedule') }}-</b>
                          {{item.repeatOn}}
                        </p>
                        <p>
                          <b>{{ $t('message.StartedDate') }}-</b>
                          {{newdate(item.startdate,'start')}}
                        </p>
                        <p>
                          <b>{{ $t('message.EndDate') }}-</b>
                          {{newdate(item.enddate,'end')}}
                        </p>
                      </div>
                      <div class="orderDetailRight">
                        <p class="activeOrder">
                          <b>{{ $t('message.Status') }}-</b>
                          {{item.Subscriptionstatus}}
                        </p>
                        <div class="amountPrice">
                          <!-- <span>Amount</span> -->
                          <sup>{{currency}}</sup>
                          {{item.subscriptionTotalPrice.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                    <div class="deliveryAddress">
                      <b>
                        <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" />
                        {{item.addresses.title}}
                      </b>
                      {{item.addresses.location}}
                    </div>
                  </div>

                  <h6 v-b-modal="'active_'+JSON.stringify(index)">
                    <span class="invoice-icon">
                      <i class="fa fa-file-text" aria-hidden="true"></i>
                    </span>Invoice
                  </h6>
                  <b-modal :id="'active_'+JSON.stringify(index)" title="Download Invoice">
                    <div class="delivery-select-new">
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="startDate" placeholder="Select Start Date"></datepicker>
                      </div>
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="endDate" placeholder="Select End Date"></datepicker>
                      </div>
                    </div>
                    <div
                      class="error"
                      v-if="(!startDate||!endDate) && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>
                    <!-- <div
                      class="error"
                      v-if="!endDate && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>-->

                    <template v-slot:modal-footer>
                      <button
                        class="btn btn-primary"
                        v-on:click="downloadLink(item)"
                      >{{ $t('message.Download') }}</button>
                    </template>
                  </b-modal>
                  <br />
                  <h5
                    v-b-toggle="'index_'+index"
                  >{{$t('message.Delivery')}} {{$t('message.Charges')}}</h5>
                  <b-collapse :id="'index_'+index" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="table-alignment">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">{{ $t('message.Monday') }}</th>
                                <th scope="col">{{ $t('message.Tuesday') }}</th>
                                <th scope="col">{{ $t('message.Wednesday') }}</th>
                                <th scope="col">{{ $t('message.Thursday') }}</th>
                                <th scope="col">{{ $t('message.Friday') }}</th>
                                <th scope="col">{{ $t('message.Saturday') }}</th>
                                <th scope="col">{{ $t('message.Sunday') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  v-for="(val, index) in item.subscription_days"
                                  :key="index"
                                >{{currency}}{{val.delivery_charge.toFixed(2)}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div v-else>
              <h4 class="text-center mt-5">{{ $t('message.SubscriptionNotFound') }}</h4>
            </div>
          </b-tab>
          <b-tab :title="$t('message.PausedSubs')">
            <div class="container" v-if="allPausedSubscription.length>0">
              <div v-for="(item, index) in allPausedSubscription" :key="index">
                <div class="panel orderList" v-if="item.Subscriptionstatus=='paused'">
                  <div v-on:click="gotoDetails(item,'paused')">
                    <div class="orderContainer">
                      <div class="productImageOrder">
                        <img class="svg" v-lazy="imageBaseUrl+item.image" alt="placeholder" />
                      </div>
                      <div class="orderDetailLeft">
                        <h4>{{item.productName}}</h4>
                        <p>
                          <!-- <b>Quantity-</b>
                          {{item.productQuantity}}-->
                        </p>
                        <p>
                          <b>{{ $t('message.Schedule') }}-</b>
                          {{item.repeatOn}}
                        </p>
                        <p>
                          <b>{{ $t('message.StartedDate') }}-</b>
                          {{newdate(item.startdate,'start')}}
                        </p>
                        <p>
                          <b>{{ $t('message.EndDate') }}-</b>
                          {{newdate(item.enddate,'end')}}
                        </p>
                      </div>
                      <div class="orderDetailRight">
                        <p class="activeOrder">
                          <b>{{ $t('message.Status') }}-</b>
                          {{item.Subscriptionstatus}}
                        </p>
                        <div class="amountPrice">
                          <!-- <span>Amount</span> -->
                          <sup>{{currency}}</sup>
                          {{item.subscriptionTotalPrice.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="deliveryAddress">
                    <b>
                      <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" />
                      {{item.addresses.title}}
                    </b>
                    {{item.addresses.location}}
                    <b-button
                      v-if="isResumeSubscription"
                      v-on:click="gotoPayment"
                    >{{ $t('message.Resume') }} {{ $t('message.Subscription') }}</b-button>
                  </div>

                  <h6 v-b-modal="'pause_'+JSON.stringify(index)">
                    <span class="invoice-icon">
                      <i class="fa fa-file-text" aria-hidden="true"></i>
                    </span>Invoice
                  </h6>
                  <b-modal :id="'pause_'+JSON.stringify(index)" title="Download Invoice">
                    <div class="delivery-select-new">
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="startDate" placeholder="Select Start Date"></datepicker>
                      </div>
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="endDate" placeholder="Select End Date"></datepicker>
                      </div>
                    </div>
                    <div
                      class="error"
                      v-if="(!startDate||!endDate) && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>
                    <!-- <div
                      class="error"
                      v-if="!endDate && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>-->

                    <template v-slot:modal-footer>
                      <button
                        class="btn btn-primary"
                        v-on:click="downloadLink(item)"
                      >{{ $t('message.Download') }}</button>
                    </template>
                  </b-modal>
                  <br />
                  <h5
                    v-b-toggle="'index_'+index"
                  >{{$t('message.Delivery')}} {{$t('message.Charges')}}</h5>
                  <b-collapse :id="'index_'+index" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="table-alignment">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">{{ $t('message.Monday') }}</th>
                                <th scope="col">{{ $t('message.Tuesday') }}</th>
                                <th scope="col">{{ $t('message.Wednesday') }}</th>
                                <th scope="col">{{ $t('message.Thursday') }}</th>
                                <th scope="col">{{ $t('message.Friday') }}</th>
                                <th scope="col">{{ $t('message.Saturday') }}</th>
                                <th scope="col">{{ $t('message.Sunday') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  v-for="(val, index) in item.subscription_days"
                                  :key="index"
                                >{{currency}}{{val.delivery_charge.toFixed(2)}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div v-else>
              <h4 class="text-center mt-5">{{ $t('message.SubscriptionNotFound') }}</h4>
            </div>
          </b-tab>
          <b-tab :title=" $t('message.CancelledSubs') ">
            <div class="container" v-if="allCancelledSubscription.length>0">
              <div v-for="(item, index) in allCancelledSubscription" :key="index">
                <div class="panel orderList" v-if="item.Subscriptionstatus=='cancel'">
                  <div v-on:click="gotoDetails(item,'cancel')">
                    <div class="orderContainer">
                      <div class="productImageOrder">
                        <img class="svg" v-lazy="imageBaseUrl+item.image" alt="placeholder" />
                      </div>
                      <div class="orderDetailLeft">
                        <h4>{{item.productName}}</h4>
                        <p>
                          <!-- <b>Quantity-</b>
                          {{item.productQuantity}}-->
                        </p>
                        <p>
                          <b>{{ $t('message.Schedule') }}-</b>
                          {{item.repeatOn}}
                        </p>
                        <p>
                          <b>{{ $t('message.StartedDate') }}-</b>
                          {{newdate(item.startdate,'start')}}
                        </p>
                        <p>
                          <b>{{ $t('message.EndDate') }}-</b>
                          {{newdate(item.enddate,'end')}}
                        </p>
                      </div>
                      <div class="orderDetailRight">
                        <p class="activeOrder">
                          <b>{{ $t('message.Status') }}-</b>
                          {{item.Subscriptionstatus}}
                        </p>
                        <div class="amountPrice">
                          <!-- <span>Amount</span> -->
                          <sup>{{currency}}</sup>
                          {{item.subscriptionTotalPrice.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="deliveryAddress">
                    <b>
                      <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" />
                      {{item.addresses.title}}
                    </b>
                    {{item.addresses.location}}
                  </div>

                  <h6 v-b-modal="'cancel_'+JSON.stringify(index)">
                    <span class="invoice-icon">
                      <i class="fa fa-file-text" aria-hidden="true"></i>
                    </span>Invoice
                  </h6>
                  <b-modal :id="'cancel_'+JSON.stringify(index)" title="Download Invoice">
                    <div class="delivery-select-new">
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="startDate" placeholder="Select Start Date"></datepicker>
                      </div>
                      <div class="with-icon">
                        <button class="calendarBtn">
                          <i class="fa fa-calendar"></i>
                        </button>
                        <datepicker v-model="endDate" placeholder="Select End Date"></datepicker>
                      </div>
                    </div>
                    <div
                      class="error"
                      v-if="(!startDate||!endDate) && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>
                    <!-- <div
                      class="error"
                      v-if="!endDate && submitStatus"
                    >{{ $t('message.DateValidation') }}</div>-->

                    <template v-slot:modal-footer>
                      <button
                        class="btn btn-primary"
                        v-on:click="downloadLink(item)"
                      >{{ $t('message.Download') }}</button>
                    </template>
                  </b-modal>
                  <br />
                  <h5
                    v-b-toggle="'index_'+index"
                  >{{$t('message.Delivery')}} {{$t('message.Charges')}}</h5>
                  <b-collapse :id="'index_'+index" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="table-alignment">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">{{ $t('message.Monday') }}</th>
                                <th scope="col">{{ $t('message.Tuesday') }}</th>
                                <th scope="col">{{ $t('message.Wednesday') }}</th>
                                <th scope="col">{{ $t('message.Thursday') }}</th>
                                <th scope="col">{{ $t('message.Friday') }}</th>
                                <th scope="col">{{ $t('message.Saturday') }}</th>
                                <th scope="col">{{ $t('message.Sunday') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  v-for="(val, index) in item.subscription_days"
                                  :key="index"
                                >{{currency}}{{val.delivery_charge.toFixed(2)}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div v-else>
              <h4 class="text-center mt-5">{{ $t('message.SubscriptionNotFound') }}</h4>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubscriptions, getDeliveryChargeInfo } from "./../services/api";
import moment from "moment";
import VueLazyload from "vue-lazyload";
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});

Vue.use(Vuelidate);

export default {
  name: "home",
  components: { Datepicker },
  validations: {
    startDate: {
      required
    },
    endDate: {
      required
    }
  },
  data() {
    return {
      isResumeSubscription: localStorage.getItem("subscriptionTmc"),
      currency: localStorage.getItem("CurrencySymbol"),
      isLoading: false,
      fullPage: true,
      allSubscriptions: "",
      allActiveSubscription: [],
      allPausedSubscription: [],
      allCancelledSubscription: [],
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      notactiveFoundmsg: "",
      notpausedFoundmsg: "",
      notcancelledFoundmsg: "",
      tabIndex: 0,
      startDate: "",
      endDate: "",
      submitStatus: false,
      disabledDates: {
        to: new Date(2016, 0, 5),
        from: new Date(2016, 0, 26)
      }
    };
  },

  created() {
    this.getSubscriptionDetails();
    // this.getDeliveryChargesDetails()
    if (this.$route.query.ti) {
      this.tabIndex = JSON.parse(this.$route.query.ti);
    }
  },
  methods: {
    downloadLink(item) {
      console.log("Item", item);
      if (this.$v.$invalid) {
        this.submitStatus = true;
      } else {
        var url =
          "https://web.staging02.com/trakop/Transactions/invoiceSubscription?date_range=" +
          moment(this.startDate).format("DD/MM/YYYY") +
          "-" +
          moment(this.endDate).format("DD/MM/YYYY") +
          "&sub_id=" +
          item.subscriptionId +
          "&type=subscription&user_id=" +
          localStorage.getItem("userId") +
          "&vendor_id=" +
          localStorage.getItem("vendorId");

        window.open(url, "_blank");
        this.startDate = "";
        this.endDate = "";
      }
    },
    openDate() {
      console.log("itj");
    },
    gotoPayment() {
      this.$router.push("payment");
    },
    gotoDetails(item, status) {
      console.log(item);
      localStorage.setItem("subscriptionStatus", status);
      localStorage.setItem("productSubscribed", JSON.stringify(item));
      this.$router.push("product-subscription");
    },
    newdate(value, date) {
      if (value) {
        if (date == "end") {
          return moment(value).format("DD MMMM, YYYY hh:mm A");
        } else {
          var a = value.split("T");
          var b =
            moment(a[0], "DD-MM-YYYY", true).format("YYYY-MM-DD") +
            "T" +
            a[1] +
            "+00:00";
          return moment(b).format("DD MMMM, YYYY hh:mm A");
        }
      }
    },
    getDeliveryChargesDetails() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          type: "0",
          vendor_id: localStorage.getItem("vendorId")
        };

        getDeliveryChargeInfo(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              console.log("####", result);
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    },
    getSubscriptionDetails() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };

        getSubscriptions(requestData)
          .then(result => {
            console.log("subs", result);
            if (result.data.successCode === 1) {
              this.allSubscriptions = result.data.subscriptionsList;
              // this.subscriptionDays = this.allSubscriptions.subscription_days;

              for (var i = 0; i < this.allSubscriptions.length; i++) {
                if (this.allSubscriptions[i].Subscriptionstatus == "active") {
                  this.allActiveSubscription.push(this.allSubscriptions[i]);
                } else if (
                  this.allSubscriptions[i].Subscriptionstatus == "cancel"
                ) {
                  this.allCancelledSubscription.push(this.allSubscriptions[i]);
                  console.log(this.allCancelledSubscription);
                } else {
                  this.allPausedSubscription.push(this.allSubscriptions[i]);
                }
              }
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
